import store from 'source/store';

function canAccessStaffPages(to, from, next) {
    const SUPERVISOR = 2;
    const MANAGER = 3;
    const user_profile = store.state.auth.user.user_profile;
    const userPk = user_profile?.pk;
    const clientPk = store.state.workforce.selectedWorkforce?.client?.pk;
    const userRole = user_profile?.user_role;
    const isSupervisorOrManager = userRole === SUPERVISOR || userRole === MANAGER;
    const isClient = userPk === clientPk;
    const isExecutive = user_profile?.is_organizational_exec || user_profile?.is_workforce_exec;
    const canAccess = isExecutive || isClient || isSupervisorOrManager;

    if (canAccess) {
        next();
    } else {
        next({ name: 'access-denied', replace: true });
    }
}
const EXECUTIVE = 0;
const SUPERVISOR = 2;
const MANAGER = 3;

const rolesToInt = {
    'executive': EXECUTIVE,
    'supervisor': SUPERVISOR,
    'manager': MANAGER
};

const intToRoles = {
    [EXECUTIVE]: 'executive',
    [SUPERVISOR]: 'supervisor',
    [MANAGER]: 'manager'
};

function returnRole(role, type) {
    if (type === 'int') {
        return rolesToInt[role];
    } else {
        return intToRoles[role];
    }
}

function redirectLink(to, from, next) {
    // Changes the role of the params.role to the user's role if they are different
    const userProfile = store.state.auth.user.user_profile;
    let userRole = userProfile?.user_role;
    const userId = store.state.auth.user.pk;

    // Check if the user is an executive within the selected workforce
    // TODO (we need to check this because the payload is a little different depending on the timing)
    const selectedWorkforce = store.state.workforce.selectedWorkforce;
    if (!selectedWorkforce) {
        console.warn('[redirectLink] Skipping until workforce is loaded');
        return next();
    }
    const isSelectedWorkforceExec = selectedWorkforce?.executives?.some(
        (executive) => executive.user_id === userId
    );

    // Assign the EXECUTIVE role if the user is an organizational or workforce-specific executive
    if (userProfile.is_organizational_exec || isSelectedWorkforceExec) {
        userRole = EXECUTIVE;
    }

    const paramsRole = returnRole(to.params.role, 'int');

    if (userRole !== paramsRole) {
        next({
            name: to.name,
            params: {
                ...to.params,
                role: returnRole(userRole, 'str')
            },
            replace: true
        });
    } else {
        next();
    }
}

export default [
    {
        path: ':role',
        name: 'staff',
        component: () => import('source/pages/root/SupervisorPageGroup.vue'),
        meta: {
            title: 'Staff - HQZen',
            canDisplayGlobalModals: true
        },
        beforeEnter: [canAccessStaffPages, redirectLink],
        children: [
            {
                path: 'partners',
                name: 'staff-employees',
                props: true,
                component: () => import('source/pages/supervisor-manager/SMEmployeesPage.vue'),
                meta: {
                    title: 'Partners - HQZen',
                    canDisplayGlobalModals: true
                },
            },
            {
                path: 'partners/details/:employment_id',
                name: 'staff-employee-details',
                component: () => import('source/pages/supervisor-manager/employees/EmployeesPage.vue'),
                props: true,
                meta: {
                    title: 'Partner Details - HQZen',
                    canDisplayGlobalModals: true
                }
            },
            {
                path: 'partners/details/:employment_id/:pcn_id',
                name: 'staff-partner-pcn-details',
                component: () => import ('source/pages/supervisor-manager/employees/PCNPartnerDetailsPage.vue'),
                props: true,
                meta: {
                    title: 'View Partner PCN Details - HQZen',
                    canDisplayGlobalModals: true
                }
            },
            {
                path: 'partners/:employment_id/contracts',
                name: 'staff-contracts',
                component: () => import('source/pages/supervisor-manager/employees/EmployeeContractsPage.vue'),
                props: true,
                meta: {
                    title: 'Partner Contract - HQZen',
                    canDisplayGlobalModals: true
                },
                children: [
                    {
                        path: 'details/:contract_id',
                        name: 'staff-contract-details',
                        component: () => import('source/pages/supervisor-manager/employees/ContractDetailsPage.vue'),
                        props: true,
                        meta: {
                            title: 'Contract Details - HQZen',
                            canDisplayGlobalModals: true
                        }
                    }
                ]
            },
            {
                path: 'partners/details/:employment_id/contract',
                name: 'staff-contract-workflow',
                component: () =>
                    import ('source/pages/employers/contracts/ContractWorkflowPage.vue'),
                props: true,
                meta: {
                    title: 'Contract - HQZen',
                    canDisplayGlobalModals: true
                }
            },
            {
                path: '201-files',
                name: 'staff-201-files',
                props: true,
                component: () => import('source/pages/supervisor-manager/SMDocumentsPage.vue'),
                meta: {
                    title: '201 Files - HQZen',
                    canDisplayGlobalModals: true
                },
            },
            {
                path: 'payroll',
                name: 'staff-payroll',
                props: true,
                component: () => import('source/pages/supervisor-manager/SMPayrollIssuesPage.vue'),
                meta: {
                    title: 'Payroll Issues - HQZen',
                    canDisplayGlobalModals: true
                },
            },
            {
                path: 'payroll/timelog-issue/:issue_id',
                name: 'staff-timelog-issue-details',
                props: true,
                component: () => import('source/pages/supervisor-manager/payroll/TimelogIssueDetailsPage.vue'),
                meta: {
                    title: 'Details - HQZen',
                    canDisplayGlobalModals: true
                }
            },
            {
                path: 'payroll/schedule-issue/:issue_id',
                name: 'staff-schedule-issue-details',
                props: true,
                component: () => import('source/pages/supervisor-manager/payroll/ScheduleIssueDetailsPage.vue'),
                meta: {
                    title: 'Details - HQZen',
                    canDisplayGlobalModals: true
                }
            },
            {
                path: 'leaves',
                name: 'staff-leaves',
                props: true,
                component: () => import('source/pages/supervisor-manager/SMLeaveRequestsPage.vue'),
                meta: {
                    title: 'Leave Requests - HQZen',
                    canDisplayGlobalModals: true
                },
            },
            {
                path: 'leaves/details/:leave_id',
                name: 'staff-leaves-details',
                props: true,
                component: () => import('source/pages/supervisor-manager/leaves/LeaveRequestDetailsPage.vue'),
                meta: {
                    title: 'Details - HQZen',
                    canDisplayGlobalModals: true
                },
            },
            {
                path: 'incident-reports',
                name: 'staff-incident-reports',
                props: true,
                component: () => import('source/pages/supervisor-manager/SMIncidentReportsPage.vue'),
                meta: {
                    title: 'Incident Reports - HQZen',
                    canDisplayGlobalModals: true
                }
            },
            {
                path: 'separations',
                name: 'staff-separations',
                props: true,
                component: () => import('source/pages/supervisor-manager/SeparationsPage.vue'),
                meta: {
                    title: 'Separations - HQZen',
                    canDisplayGlobalModals: true
                },
            },
            {
                path: 'separations/:employment_pk/details/:resignation_pk',
                name: 'staff-resignations-details',
                props: true,
                component: () => import('source/pages/supervisor-manager/separations/ResignationDetailsPage.vue'),
                meta: {
                    title: 'Resignation Details - HQZen',
                    canDisplayGlobalModals: true
                }
            },
            {
                path: 'separations/clearance-details/:clearance_pk',
                name: 'staff-clearance-details',
                props: true,
                component: () =>
                    import('source/components/supervisor-manager/separation/clearance/ClearanceDetailsPage.vue'),
                meta: {
                    title: 'Clearance Details - HQZen',
                    canDisplayGlobalModals: true
                }
            },
            {
                path: 'separations/forced-termination/:separation_pk',
                name: 'staff-forced-termination-details',
                props: true,
                component: () =>
                    import('source/components/supervisor-manager/separation/forced-termination/ForcedTerminationDetailsPage.vue'),
                meta: {
                    title: 'Forced Termmination Details - HQZen',
                    canDisplayGlobalModals: true
                }
            },
            {
                path: 'incident-reports/:ir_id/details',
                name: 'staff-incident-reports-details',
                props: true,
                component: () => import('source/pages/supervisor-manager/ir/IncidentReportDetailsPage.vue'),
                meta: {
                    title: 'Details - HQZen',
                    canDisplayGlobalModals: true
                },
            },
            {
                path: 'disciplinary-action-form/:daf_id/details',
                name: 'staff-daf-details',
                props: true,
                component: () => import('source/pages/supervisor-manager/daf/DisciplinaryActionFormDetailsPage.vue'),
                meta: {
                    title: 'Details - HQZen',
                    canDisplayGlobalModals: true
                }
            },
            {
                path: 'disciplinary-action-form',
                name: 'staff-disciplinary-action-form',
                props: true,
                component: () => import('source/pages/supervisor-manager/SMDafPage.vue'),
                meta: {
                    title: 'Disciplinary Actions - HQZen',
                    canDisplayGlobalModals: true
                }
            },
            {
                path: 'administrative-leaves',
                name: 'staff-administrative-leaves',
                props: true,
                component: () => import('source/pages/supervisor-manager/SMAdministrativeLeavesPage.vue'),
                meta: {
                    title: 'Administrative Leaves - HQZen',
                    canDisplayGlobalModals: true
                }
            },
            {
                path: 'administrative-leaves/details/:admin_leave_id',
                name: 'staff-administrative-leaves-details',
                props: true,
                component: () => import(
                    'source/pages/supervisor-manager/administrative-leaves/AdministrativeLeavesDetailsPage.vue'
                ),
                meta: {
                    title: 'Details - HQZen',
                    canDisplayGlobalModals: true
                },
            },
            {
                path: 'accountabilities',
                name: 'staff-accountabilities',
                props: true,
                component: () => import('source/pages/supervisor-manager/SMAccountabilitiesPage.vue'),
                meta: {
                    title: 'Accountabilities - HQZen',
                    canDisplayGlobalModals: true
                }
            },
            {
                path: 'accountabilities/details/:accountability_id',
                name: 'staff-accountabilities-details',
                props: true,
                component: () =>
                    import('source/pages/supervisor-manager/accountabilities/AccountabilityDetailsPage.vue'),
                meta: {
                    title: 'Details - HQZen',
                    canDisplayGlobalModals: true
                },
            },
            {
                path: 'scheduled-tasks',
                name: 'staff-scheduled-tasks',
                component: () =>
                    import ('source/pages/schedules/ScheduledTasksPage.vue'),
                props: true,
                meta: {
                    title: 'Scheduled Tasks - HQZen',
                    loginRequired: true,
                    canDisplayGlobalModals: true,
                },
            },
            {
                path: 'scheduled-tasks/view/:assignee_id/:employment_id',
                name: 'view-staff-scheduled-tasks',
                component: () =>
                    import ('source/pages/schedules/EmployeeScheduledTasksPage.vue'),
                props: true,
                meta: {
                    title: 'Partner Scheduled Tasks - HQZen',
                    loginRequired: true,
                    canDisplayGlobalModals: true,
                }
            },
            {
                path: 'platform-settings',
                name: 'staff-platform-settings',
                component: () =>
                    import (
                        'source/pages/employers/administrator/sub-sections/PlatformSettingsManager.vue'
                    ),
                props: true,
                meta: {
                    title: 'Platform Settings - HQZen',
                    canDispladashboardyGlobalModals: true,
                },
            },
            {
                path: 'edit-platform-settings/:setting_id',
                name: 'staff-edit-platform-settings',
                component: () =>
                    import (
                        'source/pages/employers/platform-settings/CreatePlatformSettingsPage.vue'
                    ),
                props: true,
                meta: {
                    title: 'Edit Platform Settings - HQZen',
                    canDispladashboardyGlobalModals: true,
                },
            },
            {
                path: 'blocked-partners',
                name: 'staff-blocked-partners',
                component: () =>
                    import (
                        'source/pages/employers/administrator/sub-sections/BlockedPartnersPage.vue'
                    ),
                props: true,
                meta: {
                    title: 'Blocked Partners - HQZen'
                },
            },
            {
                path: 'blocked-partners/details/:employment_id',
                name: 'staff-blocked-partners-details',
                props: true,
                component: () => import(
                        'source/components/supervisor-manager/blocked-partners/BlockedPartnersDetailsPage.vue'
                ),
                meta: {
                    title: 'Blocked Partner Details - HQZen',
                },
            },
            // TODO (rob@bposeats.com): decide how to deal with the routing here.
            // This was placed here so when creating a schedule is done, we can redirect back here
            // no problem and provide a query param to automatically open the edit schedule modal.
            {
                path: 'create-schedule',
                name: 'staff-create-schedule',
                component: () =>
                    import ('source/pages/schedules/CreateSchedulePage.vue'),
                props: true,
                meta: {
                    title: 'Create Schedule - HQZen',
                    loginRequired: true,
                    canDisplayGlobalModals: true,
                },
            },
        ]
    }
];
